export default __webpack_public_path__ + "static/media/boxtype11.e79489b4.JPG";